var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebars-wrapper position-relative"},_vm._l((_vm.sidebars),function(sidebarItem){return _c('sidebar-base',{key:sidebarItem.id,attrs:{"sidebar":sidebarItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }